import { createStyles, Theme } from '@material-ui/core'

export const styles = (theme: Theme) =>
  createStyles({
    // dropZone: {
    //   minHeight: '150px',
    //   height: '150px',
    //   padding: theme.spacing(2)
    // },
    root: {
      margin: 0,
      padding: theme.spacing(2)
    },
    previewChip: {
      minWidth: 160,
      maxWidth: 210,
      padding: theme.spacing(2)
    },
    cardHeight: {
      height: '100%'
    },
    dialogActionsRoot: {
      margin: '14px'
    },
    dropZone: {
      minHeight: '170px',
      height: '210px'
    },
    formCustomTitle: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '0px',
      margin: '0px',
      width: '100%'
    },
    dialogTitle: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    templateButton: {
      color: theme.palette.grey[500]
    }
  })
